import { motion } from "framer-motion";
import {
  TASK_STATUS_LABELS,
  MESSAGES,
  getStatusIconAndColor,
} from "../Constants";

const SubTaskDetailsInfo = ({ subTasks = [] }) => {
  return (
    <div className="flex flex-col overflow-y-auto h-full px-2">
      <div className="flex justify-between items-center mb-2">
        <h3 className="text-lg font-semibold text-primary border-b-2 border-gray-300 pb-1">
          Sub Task Details
        </h3>
      </div>

      {subTasks.length > 0 ? (
        <div className="divide-y divide-gray-200 overflow-y-auto">
          {subTasks.map((task, index) => {
            const { icon, color } = getStatusIconAndColor(task.status);
            return (
              <motion.div
                key={task.id || index}
                initial={{ opacity: 0, y: 5 }}
                animate={{ opacity: 1, y: 0 }}
                className="flex md:justify-start justify-between py-2"
              >
                <p className="text-sm font-medium text-gray-800 w-[35%] truncate">
                  {task.title || "Untitled Sub-task"}
                </p>

                <p className="hidden md:block text-sm font-medium text-gray-800 w-[10%] truncate">
                  {task.weight || "-"}
                </p>

                <div className="text-sm text-gray-600 truncate w-[40%] md:text-center text-left">
                  {task.assigned_to ? (
                    <span>
                      {task.assigned_to.first_name} {task.assigned_to.last_name}
                    </span>
                  ) : (
                    <p className="text-gray-400 italic mt-1">
                      {MESSAGES.NOT_ASSIGNED_YET}
                    </p>
                  )}
                </div>

                <div
                  className={`flex items-center gap-1 text-xs font-medium px-2 py-1 rounded-full  ${color}`}
                >
                  {icon}
                  <span>{TASK_STATUS_LABELS[task.status] || task.status}</span>
                </div>
              </motion.div>
            );
          })}
        </div>
      ) : (
        <p className="text-gray-400 text-sm text-center py-6">
          {MESSAGES.NO_SUB_TASKS}
        </p>
      )}
    </div>
  );
};

export default SubTaskDetailsInfo;
